module.exports = __webpack_public_path__ + "static/media/ic_sec_finance.e08c8fb5.svg";